import { badges } from "@/mocks/artistData";

export default function MyBadges() {
  const earned = badges.filter((b) => b.earned);
  const locked = badges.filter((b) => !b.earned);

  return (
    <div>
      <h3 className="text-white font-bold text-base mb-4 flex items-center gap-2">
        <i className="ri-award-line text-[#ff8c42]" />
        획득한 배지
        <span className="text-white/30 text-sm font-normal">
          {earned.length}/{badges.length}
        </span>
      </h3>

      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3 mb-6">
        {earned.map((b) => (
          <div
            key={b.id}
            className="flex flex-col items-center gap-2 p-3 rounded-xl border border-white/10 bg-white/[0.04] hover:border-white/20 transition-all cursor-default"
          >
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl"
              style={{ background: `${b.color}20`, border: `1px solid ${b.color}40` }}
            >
              <i className={`${b.icon} text-lg`} style={{ color: b.color }} />
            </div>
            <span className="text-white/70 text-[10px] text-center leading-tight font-medium">{b.name}</span>
          </div>
        ))}
      </div>

      {locked.length > 0 && (
        <>
          <h4 className="text-white/30 text-sm font-semibold mb-3 flex items-center gap-2">
            <i className="ri-lock-line text-xs" />
            잠긴 배지
          </h4>
          <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3">
            {locked.map((b) => (
              <div
                key={b.id}
                className="flex flex-col items-center gap-2 p-3 rounded-xl border border-white/5 bg-white/[0.02] cursor-default group relative"
                title={b.description}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/8">
                  <i className={`${b.icon} text-lg text-white/15`} />
                </div>
                <span className="text-white/20 text-[10px] text-center leading-tight font-medium">{b.name}</span>
                {/* Tooltip */}
                <div className="absolute -top-9 left-1/2 -translate-x-1/2 bg-[#1a1a2e] border border-white/15 rounded-lg px-2.5 py-1.5 text-[10px] text-white/60 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                  {b.description}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
